import request from '@/utils/http';

const getBalanceList = async (params) => request({
  method: 'get',
  url: '/get-blance',
  params,
});

export default {
  getBalanceList,
};
